import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAnalyticsStore = defineStore('analytics', () => {
  const sessionId = ref(null);

  function initSession() {
    // Récupérer sessionId depuis sessionStorage ou en créer un nouveau
    const storedSessionId = sessionStorage.getItem('analyticsSessionId');

    if (storedSessionId) {
      sessionId.value = storedSessionId;
    } else {
      sessionId.value = generateSessionId();
      sessionStorage.setItem('analyticsSessionId', sessionId.value);
    }
  }

  function generateSessionId() {
    return `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
  }

  async function trackVisit(pageUrl, pageType, pageName = null) {
    if (!sessionId.value) {
      initSession();
    }

    const data = {
      sessionId: sessionId.value,
      pageUrl,
      pageType,
      pageName,
    };

    try {
      await fetch('/track-visit.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
    } catch (error) {
      // Tracking silencieux : ne pas bloquer l'app si ça échoue
      console.debug('Analytics tracking failed:', error);
    }
  }

  return {
    sessionId,
    initSession,
    trackVisit,
  };
});
